<div class="container p-5" *ngIf="aiAgent.outBoundSettings">
    <div class="row">
        <h1 class="mb-1">Unanswered calls</h1>
        <h4 class="mb-0">View your answered outbound calls</h4>
    </div>
    <div class="row">
        <div class="col-12 d-flex justify-content-end pb-5">
            <button mat-raised-button (click)="onConfigureAutoCallBack()">
                <mat-icon>add</mat-icon>
                Configure Auto Callback
            </button>
        </div>
    </div>

    <h1 *ngIf="aiAgent.outBoundSettings!.inTransitCalls.length == 0">No Missed calls.</h1>

    <div class="mat-elevation-z8" [hidden]="aiAgent.outBoundSettings!.inTransitCalls.length == 0">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="Target phone number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Target phone number</th>
                <td mat-cell *matCellDef="let row"> {{row.targetPhoneNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="Created">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                <td mat-cell *matCellDef="let row"> {{row.created}}</td>
            </ng-container>

            <ng-container matColumnDef="Auto CallBack Scheduled Date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Auto CallBack Scheduled Date</th>
                <td mat-cell *matCellDef="let row"> {{row.scheduledCallBack}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>
